import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';

const ContactForm = () => {
  const { t } = useTranslation();
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    subject: '',
    message: ''
  });

  const handleSubmit = (event) => {
    event.preventDefault();
    alert(t('design.support.contactSaved'));
  };

  return (
    <form onSubmit={handleSubmit} className="grid gap-5">
      <div className="grid gap-5 md:grid-cols-2">
        <div>
          <label className="field-label">{t('support.contact.form.fullName')}</label>
          <input type="text" required className="input-shell" value={formData.name} onChange={(event) => setFormData((current) => ({ ...current, name: event.target.value }))} />
        </div>
        <div>
          <label className="field-label">{t('support.contact.form.email')}</label>
          <input type="email" required className="input-shell" value={formData.email} onChange={(event) => setFormData((current) => ({ ...current, email: event.target.value }))} />
        </div>
      </div>
      <div>
        <label className="field-label">{t('support.contact.form.subject')}</label>
        <input type="text" required className="input-shell" value={formData.subject} onChange={(event) => setFormData((current) => ({ ...current, subject: event.target.value }))} />
      </div>
      <div>
        <label className="field-label">{t('support.contact.form.message')}</label>
        <textarea rows="6" required className="input-shell" value={formData.message} onChange={(event) => setFormData((current) => ({ ...current, message: event.target.value }))} />
      </div>
      <button type="submit" className="btn-primary w-full justify-center sm:w-auto">{t('support.contact.form.send')}</button>
    </form>
  );
};

export default ContactForm;
